import { Bell } from "lucide-react";
import { useLocation } from "wouter";
import { Button } from "@/components/ui/button";
import { useUnreadCount } from "@/hooks/use-notifications";
import { apiClient } from "@/lib/api-client";

export function NotificationBell() {
  const [, navigate] = useLocation();
  const { data: unreadCount } = useUnreadCount();

  // Only render when authenticated
  if (!apiClient.getToken()) return null;

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => navigate("/notifications")}
      aria-label="Notifications"
      className="relative"
      data-testid="button-notification-bell"
    >
      <Bell className="h-5 w-5" />
      {unreadCount != null && unreadCount > 0 && (
        <span
          className="absolute top-1.5 end-1.5 h-2.5 w-2.5 rounded-full bg-red-500 ring-2 ring-background"
          data-testid="notification-unread-badge"
        />
      )}
    </Button>
  );
}
